const CARRIER_SEPARATOR = ' ';
const NATIVE_SEPARATOR = 'T';

// input[type=datetime-local]'s own value is either a complete 'YYYY-MM-DDTHH:mm' or '' -- the
// browser itself refuses to report a half-entered one, so there is no partial case to carry here.
export function toDateTimeLocalValue(carrierValue: string): string {
  if (!carrierValue) {
    return '';
  }
  const [datePart, timePart] = carrierValue.split(CARRIER_SEPARATOR);
  return `${datePart}${NATIVE_SEPARATOR}${(timePart ?? '').slice(0, 5)}`;
}

// input[type=datetime-local] carries no seconds -- any edit zeroes a stored non-zero value.
export function fromDateTimeLocalValue(nativeValue: string): string {
  if (!nativeValue) {
    return '';
  }
  const [datePart, timePart] = nativeValue.split(NATIVE_SEPARATOR);
  return `${datePart} ${timePart}:00`;
}
